import { Injectable } from '@angular/core';
import { ApiUrlHelper } from '../api-url-helper';
import { GenreTransformer } from '../../_transformers/genre.transformer';
import { HttpClientHelper } from '../http-helper';
import { map } from 'rxjs/operators';

@Injectable()
export class GenreService {
    constructor(
        private _apiUrlHelper: ApiUrlHelper,
        private _genreTransformer: GenreTransformer,
        private _httpClientHelper: HttpClientHelper
    ) {
    }

    getGenres(cid = "0,1", alterLink = false, useregion = false, fromSubIndex = false) {
        // console.log(categoryId, "(((((((")
        const arr = cid.split(',')
        if (arr.length > 3) {
            arr.pop()
        }
        cid = arr.join(',')
        const apiURL = this._apiUrlHelper.urlBuilder('all-video-genres', { cid, isRegion: useregion });
       // console.log(apiURL)
        return this._httpClientHelper.get(apiURL)
            .pipe(map((res) => {
                if (cid === '0,1,4' && fromSubIndex) {
                    return res.filter(item => item.region !== "-1").map(item => {
                        return this._genreTransformer.fromCatType(item, alterLink);
                    });
                }
                return res.map(item => {
                    return this._genreTransformer.fromCatType(item, alterLink);
                });
            }));
    }

    // getGenreApiKey(categoryId) {
    //     return 'all-video-genres';
    //     switch (categoryId) {
    //         case 1:
    //             return 'video-genre';
    //         case 2:
    //             return 'drama-genre';
    //         case 3:
    //             return 'variety-genre';
    //         case 4:
    //             return 'anime-genre';
    //         case 5:
    //             return 'sport-genre';
    //         case 6:
    //             return 'documentary-genre';
    //         case 7:
    //             return 'chinese-genre';
    //         case 8:
    //             return 'game-genre';
    //         default:
    //             return undefined;
    //     }
    // }
}
